module.exports = __webpack_public_path__ + "static/media/bg.16c546da.png";